import React from 'react';
import Immutable from 'immutable';

import { Node } from '@uncinc/react-drupal-core';
import { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import { NodeDocument } from '../../../types/uncinc_profile/nodes';

import './style.scss';


interface ViewDocumentsHighlightedProps {
  entities: Immutable.List<ImmutableEntity<NodeDocument>>;
}

const ViewDocumentsHighlighted: React.FC<ViewDocumentsHighlightedProps> = ({
  entities,
}) => (
  <div className="ViewDocumentsHighlighted">
    <div className="row">
      {entities.map((entity) => {
        const document = entity.toJS();
        const uuid = document.uuid[0].value;
        const langcode = document.langcode[0].value;
        const key = `${uuid}:${langcode}`;

        return (
          <div className="col-12 col-lg-6" key={key}>
            <Node
              entity={entity}
              viewMode="teaser"
            />
          </div>
        );
      })}
    </div>
  </div>
);

export default ViewDocumentsHighlighted;
